import { Link } from 'react-router-dom'

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
      {/* Top bar */}
      <div className="max-w-4xl mx-auto px-4 pt-4 flex justify-end">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors text-sm font-medium"
        >
          Войти через Telegram
        </Link>
      </div>

      {/* Hero section */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <img
            src="/logo.png"
            alt="Fluffy Fox Ear"
            className="w-64 h-auto mx-auto mb-6"
          />
          <p className="text-xl text-gray-600">
            Сервис транскрибации защит диссертаций
          </p>
        </div>

        {/* Description */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Что это такое?
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Fluffy Fox Ear — это сервис для автоматической транскрибации аудио- и видеозаписей
            защит диссертаций. Мы используем современные технологии распознавания речи
            и искусственный интеллект для создания точных текстовых расшифровок.
          </p>
          <ul className="space-y-2 text-gray-600">
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">●</span>
              <span>Автоматическое распознавание речи с высокой точностью</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">●</span>
              <span>Разделение по спикерам (диссертант, оппоненты, комиссия)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">●</span>
              <span>Структурирование по этапам защиты</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">●</span>
              <span>Распознавание научных терминов и аббревиатур</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-orange-500 mt-1">●</span>
              <span>Удобный веб-редактор для исправлений</span>
            </li>
          </ul>
        </div>

        {/* How to use */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Как пользоваться?
          </h2>
          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-bold">
                1
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-1">Откройте Telegram-бота</h3>
                <p className="text-gray-600">
                  Перейдите в <a href="https://t.me/Fluffy_Fox_Ear_Bot" className="text-orange-600 hover:underline">@Fluffy_Fox_Ear_Bot</a> и
                  нажмите "Начать" для регистрации.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-bold">
                2
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-1">Отправьте ссылку на файл</h3>
                <p className="text-gray-600">
                  Отправьте боту ссылку на аудио- или видеофайл из Облака Mail.ru или Яндекс.Диска.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-bold">
                3
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-1">Дождитесь обработки</h3>
                <p className="text-gray-600">
                  Бот скачает файл, извлечёт аудио и создаст транскрипт.
                  Это может занять некоторое время в зависимости от длительности записи.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center font-bold">
                4
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-1">Получите результат</h3>
                <p className="text-gray-600">
                  После завершения вы получите ссылку на веб-страницу с транскриптом,
                  где можно прослушать аудио, отредактировать текст и экспортировать результат.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="https://t.me/Fluffy_Fox_Ear_Bot"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-8 py-4 rounded-xl text-lg font-medium hover:from-orange-600 hover:to-amber-600 transition shadow-lg hover:shadow-xl"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.692-1.653-1.123-2.678-1.799-1.185-.781-.417-1.21.258-1.911.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.139-5.062 3.345-.479.329-.913.489-1.302.481-.428-.009-1.252-.242-1.865-.442-.751-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.015 3.333-1.386 4.025-1.627 4.477-1.635.099-.002.321.023.465.141.121.1.154.234.17.332.015.099.035.323.02.498z"/>
            </svg>
            Начать в Telegram
          </a>
          <p className="text-gray-500 text-sm mt-4">
            Бесплатно для тестирования
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center text-gray-500 text-sm">
          <p>Fluffy Fox Ear &copy; 2026</p>
        </div>
      </footer>
    </div>
  )
}
